import noop from 'lodash/noop';

import createReducer from '../utils/createReducer';
import switchFunc from '../utils/switchFunc';
import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  RESET_GIFTSTORE,
  RESET_GIFTSTORE_ERRORS
} from '../constants/actionTypes';
import { GIFTSTORE_PRODUCTS, GIFTSTORE_PURCHASES, GIFTSTORE_REDEEM } from '../constants/apiTypes';
import decodeProduct from '../normalizers/decodeProduct';
import decodePurchase from '../normalizers/decodePurchase';

const initialState = {
  errors: null,
  isLoading: true,
  isPurchasing: false,
  products: [],
  promoText: '',
  purchases: [],
  purchasesPagination: {}
};

const apiCallRequestReducer = switchFunc(
  {
    [GIFTSTORE_PRODUCTS]: () => ({
      errors: null,
      isLoading: true
    }),
    [GIFTSTORE_PURCHASES]: () => ({
      errors: null,
      isLoading: true
    }),
    [GIFTSTORE_REDEEM]: () => ({
      errors: null,
      isPurchasing: true
    })
  },
  () => noop
);

const apiCallSuccessReducer = switchFunc(
  {
    [GIFTSTORE_PRODUCTS]: (state, action) => ({
      isLoading: false,
      products: action.data.map(decodeProduct),
      promoText: action.meta.promotional_text
    }),
    [GIFTSTORE_PURCHASES]: (state, action) => ({
      isLoading: false,
      purchases: action.data.map(decodePurchase),
      purchasesPagination: action.meta.pagination
    }),
    [GIFTSTORE_REDEEM]: () => ({
      isPurchasing: false
    })
  },
  () => noop
);

const apiCallFailureReducer = switchFunc(
  {
    [GIFTSTORE_PRODUCTS]: (state, action) => ({
      errors: action.errors,
      isLoading: false
    }),
    [GIFTSTORE_PURCHASES]: (state, action) => ({
      errors: action.errors,
      isLoading: false
    }),
    [GIFTSTORE_REDEEM]: (state, action) => ({
      errors: action.errors,
      isPurchasing: false
    })
  },
  () => noop
);

const giftstoreReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiCallRequestReducer(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCallSuccessReducer(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCallFailureReducer(action.api)(state, action),
  [RESET_GIFTSTORE_ERRORS]: () => ({
    errors: null
  }),
  [RESET_GIFTSTORE]: () => initialState
});

export default giftstoreReducer;
